import React from 'react';
import { connect } from 'react-redux'
import { redirectTo } from '../../action/redirection'
import Cart from '../Cart/floatingCart/index'
import * as cartProductDetailsAction from '../../action/cartProductDetailsAction';
import { Utils } from '../../util/utils';
import { Pages } from '../../constants/actionType'
import * as accessoriesAction from '../../action/accessoriesAction'
import * as productsAction from '../../action/productsAction'
import { updatePageLogs, checktime, catchJSException } from './../../service/logService';
import { getDTMInit } from './../../service/dtmTag';
import { getVZDLInit } from './../../service/vzdl';
import { updateSCTags } from './../../service/dtmTag';
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";

class AccessoriesHeader extends React.PureComponent {

    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.onBlurHandler =this.onBlurHandler.bind(this);
        this.onEscape = this.onEscape.bind(this);
        this.state = {
            width: '0px', display: 'none',
            popupVisible: false,
            selectedCat: '',
            consumerContent: '',
            businessContent: '',
            pageName: '',
            filterCondition: {
                categoryId: '',
                color: [],
                brand: [],
                compatibility: [],
                price: '',
                final: ''

            }
        }
    }
    // changeColor(){
    //     this.setState({width: '109px', display: 'block'})
    // }
    handleClick(value) {
        try {
            // let categoryInfo = this.props.categoriesState;
            // let categoryName = "";
            // if (categoryInfo && categoryInfo.categoryDetails && categoryInfo.categoryDetails.categoryName) {
            //     categoryName = categoryInfo.categoryDetails.categoryName.name;
            // }else{
            //     categoryName = value;
            // }           
            
            if (!this.state.popupVisible) {
                
                let txnData = {
                    total : this.props.cartProduct.total,
                    taxAmt : this.props.cartProduct.tax,
                    shippingZip : "",
                    shippingCharge : this.props.cartProduct.shippingcrg,
                    paymentType : "",
                    status : ""
                }
                //getVZDLInit(this.props.appState.visitId,this.state.pageName,"","","categories_list","","Accessories","","",{cartData : this.props.cartProduct.cartProduct,txnData : txnData});
                document.addEventListener('click', this.handleOutsideClick, false);
            } else {
                document.removeEventListener('click', this.handleOutsideClick, false);
            }

            this.setState(prevState => ({
                popupVisible: !prevState.popupVisible,
            }));
            /**hide filteroption if opened for mobile view */
            let mvaType = this.props.appState.mvaType ? this.props.appState.mvaType : "";
            if(Utils.isMobileView() && this.props.filterFlag){            
                    productsAction.setFilterFlag(this.props.dispatch, false);               
            }
        } catch (ex) {
            catchJSException('accessoriesHeader', this.props.appState.visitId, 'handleClick', ex);
        }
    }

    handleOutsideClick(e) {
        try {
            if (this.node && this.node.contains(e.target)) {
                return;
            }
            this.handleClick();
        } catch (ex) {
            catchJSException('accessoriesHeader', this.props.appState.visitId, 'handleOutsideClick', ex);
        }

    }
    /**close dropdown on escape or focus out */
    onBlurHandler(e) {
       let isMobileView = Utils.isMobileView();
        if(!e.currentTarget.contains(e.relatedTarget) && !isMobileView){
            if (this.state.popupVisible) {
              setTimeout(() => {
                  this.setState({
                      popupVisible: false
                  });
                });
            
          }
        }
        }
  
        onEscape(e){
            if(e.keyCode === 27){
              this.onBlurHandler(e);
            }
  
        }
    componentWillMount(){
        let categoryList = this.props.categoriesState && this.props.categoriesState.categoriesExp
        let productList = this.props.productstate && this.props.productstate.productsExp

        let urlName = this.props.props ? this.props.props.match.params.pageName : this.props.match.params.pageName
        let pageName = ""
        if (pageName === "" && Utils.isNotNull(categoryList)) {
            pageName = categoryList.find(obj => obj.modifiedName === urlName)
        }
        // if (pageName === undefined && Utils.isNotNull(featuredAcessoriesList)) {
        //     pageName = featuredAcessoriesList.find(obj => obj.modifiedName === urlName)
        // }
        // if (pageName === undefined && Utils.isNotNull(othersViewedList)) {
        //     pageName = othersViewedList.find(obj => obj.modifiedName === urlName)
        // }
        if (pageName === "" && Utils.isNotNull(productList)) {
            pageName = productList.find(obj => obj.modifiedName === urlName)
        }        
        if (window.location.pathname === "/home/accessories/") {
            pageName = "home"
        } 
        if (window.location.pathname === "/home/accessories/shoppingcart/") {
            pageName = "ShoppingCart"
        } 
        if (urlName !== undefined && urlName !== "") {
            pageName = pageName ? pageName.name : urlName.replace(/[-]/g, " ")
        }
        this.setState({
            pageName: pageName
        })
    }
    componentDidMount() {
        cartProductDetailsAction.showCart(true, this.props.dispatch)
        checktime(this.callCheckTime('WillMount'));
        this.processPageAfterVisitID()
    }
    processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'AccessoriesHeader',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })


    OnClick = ((selectedPrd) => {

        try {
            let request = {
                // "categoryId": selectedPrd.categoryId,
                "categoryName": selectedPrd
            }
            accessoriesAction.storeCategoryId(this.props.dispatch, request)
            let selectedPrds = Utils.removeSpecialChars(selectedPrd.seoKw)
            // let redirectURL=Pages.Category+selectedPrds
            // redirectTo(redirectURL,this.props.dispatch)
            if (this.props.filterDataValue === undefined || this.props.filterDataValue === null) {
                let filterStoreValue = this.state.filterCondition
                filterStoreValue['categoryId'] = selectedPrd.categoryId
                productsAction.setFilterData(this.props.dispatch, filterStoreValue)
            }
            else if (this.props.filterDataValue.categoryId !== selectedPrd.categoryId) {
                let filterStoreValue = this.state.filterCondition
                filterStoreValue['categoryId'] = selectedPrd.categoryId
                productsAction.setFilterData(this.props.dispatch, filterStoreValue)
            }
            else {
                let filterStoreValue = this.props.filterDataValue
                filterStoreValue['categoryId'] = selectedPrd.categoryId
                productsAction.setFilterData(this.props.dispatch, filterStoreValue)
            }
            // let transactionData = {
            //     visitId: this.props.appState.visitId
            // }            
            // getDTMInit("accessoriesCategories", selectedPrd.name, "", "", "", "", "", "", transactionData);            
            let redirectURL = Pages.Category + selectedPrds + "/";
            redirectTo(redirectURL, this.props.dispatch)
        } catch (ex) {
            catchJSException('accessoriesHeader', this.props.appState.visitId, 'OnClick', ex);
        }
    })

    showCart = () => {
        try {
            updateSCTags("header: my cart");
            let txnData = {
                total : this.props.cartProduct.total,
                taxAmt : this.props.cartProduct.tax,
                shippingZip : "",
                shippingCharge : this.props.cartProduct.shippingcrg,
                paymentType : "",
                status : ""
            }
            getVZDLInit(this.props.appState.visitId,this.state.pageName,"","","My Cart","cartView","Accessories","","",{cartData : this.props.cartProduct.cartProduct,txnData : txnData});
            cartProductDetailsAction.showCart(this.props.cartProduct.showCart, this.props.dispatch);
        } catch (ex) {
            catchJSException('accessoriesHeader', this.props.appState.visitId, 'OnClshowCartick', ex);
        }
    }

    OnViewcartClick = (() => {
        try {
            updateSCTags("view cart");
            let redirectURL = Pages.ShoppingCart;
            redirectTo(redirectURL, this.props.dispatch);
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'OnViewcartClick', ex);
        }
    })

    htmlParserTransform = (node, index) => {
        if (node.type === "tag" && node.name === "li" && node.attribs.class === "toolbar_shipping-item text-brand-1") {
            return convertNodeToElement(node, index, this.htmlParserTransform)
        }
        else if (node.name === "script" && node.type === "script") {
            let url = this.props.props.match.path;
            if (url.indexOf("/home/") === 0) {
                return this.state.consumerContent
            } else {
                return this.state.businessContent
            }
        }
    }

    OnHomeIconClick = (() => {
        try {
            let mvaType = this.props.appState.mvaType ? this.props.appState.mvaType : "";
            //let redirectURL = (mvaType === "vzt" || mvaType === "vzw") ? Pages.Shop+mvaType+"/" :  Pages.Category;
            let redirectURL="";
            if(mvaType === "vzt" || mvaType === "vzw"){
             redirectURL = this.props.appState.isMVAFiosEqipFlow ? Pages.Shop+mvaType+"/"+ "?fioseqp" :  Pages.Shop+mvaType+"/";
            }else{
                redirectURL = Pages.Category;
            }
            redirectTo(redirectURL, this.props.dispatch);
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'OnHomeIconClick', ex);
        }
    })

    render() {
        let headerContent = '';
        if (this.props.appState && this.props.appState.headerContent) {
            headerContent = this.props.appState.headerContent.description;
        }
        if (Utils.isNotNull(headerContent)) {
            // let consumerContent = headerContent.substring(140, 183);
            // let businessContent = headerContent.substring(214, 260);
            // this.setState({
            //     consumerContent: consumerContent,
            //     businessContent: businessContent
            // })
            let content = '';
            let splittedSTR = headerContent.split("document.write('");
            if (splittedSTR.length > 0) {
              for (let i = 1; i <= splittedSTR.length - 2; i++) {
                content = splittedSTR[i] ? splittedSTR[i].slice(0, splittedSTR[i].indexOf("'")) : '';
              }
              this.setState({ consumerContent: content });
            }
          }
      

        let deviceType = Utils.isMobileView()
        let cartProductcount = 0;
        let hide_Cart_filter = this.props.hide_Cart_filter ? true : false;
        let isMva = this.props.isMva ? true : false;
        if (this.props.cartProduct && this.props.cartProduct.cartProduct) {
            for (var i = 0; i < this.props.cartProduct.cartProduct.length; i++) {
                cartProductcount = parseInt(cartProductcount) + parseInt(this.props.cartProduct.cartProduct[i].qty)
            }
        }
        let currentUrl = this.props.props ? this.props.props.match.params.pageName : this.props.match.params.pageName
        // let selectedCat=currentUrl&&this.props.categoriesState.categoryDetails?this.props.categoriesState.categoryDetails.categoryName.name:this.props.productstate.pageinfo.categoryName
        let selectedCat = currentUrl && this.props.productstate.pageinfo ? this.props.productstate.pageinfo.categoryName : ''
        // let btn_class = this.state;
        let accessoriesList = []
        if (this.props.accessoriesHeaderValue && this.props.accessoriesHeaderValue.categoriesExp && this.props.accessoriesHeaderValue.categoriesExp.length) {
            this.props.accessoriesHeaderValue.categoriesExp.map((accessoriesHeaderList, index) => (
                accessoriesList.push(
                    <li aria-current={`${(accessoriesHeaderList.name) === selectedCat ? 'true' : 'false'}`} className={`${(accessoriesHeaderList.name) === selectedCat ? 'active' : ''}`} id="accessoriesList" onClick={() => { this.OnClick(accessoriesHeaderList); this.handleClick(accessoriesHeaderList.name) }} onKeyPress={() => { this.OnClick(accessoriesHeaderList); this.handleClick(accessoriesHeaderList.name) }} key={index} tabIndex="0" role="link">{accessoriesHeaderList.name}</li>
                )
            )
            )

        }

        return (

            <React.Fragment>

                <div className="w_toolbar m_toolbar" style={{ display: 'block', position: hide_Cart_filter ? "" : "sticky", top: "0" }} data-toolbar="">
                    <input type="hidden" name="cartFlyoutTime" id="cartFlyoutTime" value="5000" className="value" aria-required="false" />
                    <div className="toolbar_width">
                    {!isMva ? 
                        <div className={hide_Cart_filter ? "toolbar_filter hide" : "toolbar_filter"}>
                            <ul className="toolbar_items">
                                {/* <!-- <li className="toolbar_home-link"><a href='/home/accessories/' onclick="scTracking('fios accessories')" >Accessories Home</a></li> --> */}
                                <li className="toolbar_home-icon active" onClick={this.OnHomeIconClick}>
                                    <a href={Pages.Category} tabIndex="-1">
                                        <span tabIndex="0" className="vzicon-home" aria-hidden='true' aria-label="Home"></span>
                                        <span className="sr-only" tabIndex='-1'>
                                            Home
                                        </span>
                                    </a>
                                </li>

                                <li className="toolbar_link margin-left-zero">
                                    <div onKeyDown={this.onEscape} onBlur={this.onBlurHandler} className="w_select-box toolbar_filter" data-dropdown-container="" ref={node => { this.node = node; }}>
                                        <button className="select-box_selected" onClick={this.handleClick} aria-expanded={this.state.popupVisible}> 
                                            {currentUrl === undefined ? <span>categories</span> :
                                                //    <span>{this.props.categoriesState.categoryDetails.categoryName.name}</span>}
                                                <span>{this.props.productstate.pageinfo.categoryName}</span>}
                                        </button>
                                        <ul className="select-box_options" data-dropdown-options="" data-option-categories="" style={{ width: '109px', display: this.state.popupVisible ? 'block' : 'none' }}>
                                            {accessoriesList}
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        :""}
                        <div className={hide_Cart_filter ? "toolbar_cart hide " : "toolbar_cart"}>
                            <div id="cartBtn" className="has-icon text-brand-1 cartbutton" data-show-cart="" onClick={(e) => { deviceType ? this.OnViewcartClick() : this.showCart() }} tabIndex="0" role="button" onKeyPress={(e) => { deviceType ? this.OnViewcartClick() : this.showCart() }} aria-label={'My Cart with' +cartProductcount + 'items'}>
                                <span>My cart</span>
                                <span className="vzicon icon-cart large text-brand-1">
                                    <span className="toolbar_count-placeholder">
                                        <span className="toolbar_count">{cartProductcount}</span>
                                    </span>
                                    <span className="sr-only">My cart</span>
                                </span>
                            </div>
                        </div>

                        <Cart showCart={this.props.cartProduct.showCart} cartHide={this.showCart} history={this.props.props} />

                        <div className="toolbar_support toolbar_text">
                            <ul className="toolbar_support-items">

                                {ReactHtmlParser(headerContent, { transform: this.htmlParserTransform })}

                                <li>
                                    {/* <span id="aimsChatIcon1" style={{border-left:'0.00px';top:0px}}></span> */}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {

        cartProduct: state.cartProductDataVTP,
        categoriesState: state.categoriesVTP,
        filterDataValue: state.productsVTP.filterData,
        appState: state.appVTP,
        productstate: state.productsVTP,
        filterFlag:state.productsVTP.filterFlag
    }
}
export default (connect(mapStateToProps)(AccessoriesHeader));

    // export default connect()(AccessoriesHeader);

